import React from 'react'

const Hero = (props) => {
    return <div className="hero">

        <div className="hero-left">
            <h3 className="hero-title">The Lucille Graham Trust</h3>
        </div>


    </div>
}

export default Hero